// Gets version for monthly cache busting
import { appVersion } from './public/ts/app.version';

if (window && appVersion) {
    window['version'] = appVersion;
}

// Import libs we depend on
import './public/ts/app-bootstrapper';
import '@meltwater/ng-translation-loader';
import 'angular-translate-interpolation-messageformat';

import './apps-ts/outputs/src/app/app';
import '@meltwater/gaf-ng-components-click-tracking';
import '@meltwater/gaf-toggle-feature';
import '@meltwater/gaf-ng-components-personalization';
import '@meltwater/gaf-ng-components-personalization/visibility_personalization_dialog.css';
import '@meltwater/wildcards-components';
import '@meltwater/connections-components';



/** WEBPACK FOOTER **
 ** ./webpack.apps.ts
 **/